import EventAccordion from '../../core/components/EventAccordion'
import { valueIsDefined } from '../../core/utils/utils'


class VendorCreditFeedAccordion extends EventAccordion {

    fetchData = async () => {
        const { vendorCreditID } = this.props

        if (valueIsDefined(vendorCreditID)) {
            const endpoint = DjangoUrls["bills:api-vendor-credits-feed-list"](window.MARKETPLACE_ENTITY_SLUG, vendorCreditID)
            const response = await fetch(endpoint)
            return await response.json()
        }
        else {
            return null
        }
    }

    getTitle = () => {
        return "Vendor Credit Timeline"
    }

    getEmphasis = () => {
        return "time"
    }
}

export default VendorCreditFeedAccordion;
